import { render, staticRenderFns } from "./CompleteRegistrationNew.vue?vue&type=template&id=76ca52ad&scoped=true&"
import script from "./CompleteRegistrationNew.vue?vue&type=script&lang=js&"
export * from "./CompleteRegistrationNew.vue?vue&type=script&lang=js&"
import style0 from "./CompleteRegistrationNew.vue?vue&type=style&index=0&id=76ca52ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ca52ad",
  null
  
)

export default component.exports